export default __webpack_public_path__ + "static/wireframe-672c02b66abd5073707ed7390d149d08.png";